export default {
  methods: {
    projectRejectionReasons (reason) {
      if (reason) {
        if (reason === 'NAWAfinancingCondition') {
          return this.$t('components.publication_element.project_rejection_reason.nawa_financing_condition')
        } else if (reason === 'AllGrantsInEvaluationPeriod') {
          return this.$t('components.publication_element.project_rejection_reason.all_grants_in_evaluation_period')
        } else if (reason === 'AnyEvaluatedSourceOfFinancing') {
          return this.$t('components.publication_element.project_rejection_reason.any_evaluated_source_of_financing')
        } else if (reason === 'FinancingInContestMode') {
          return this.$t('components.publication_element.project_rejection_reason.financing_in_contest_mode')
        } else if (reason === 'ProjectManagerStatementsCondition') {
          return this.$t('components.publication_element.project_rejection_reason.project_manager_statements_condition')
        } else if (reason === 'ScienceDissemination') {
          return this.$t('components.publication_element.project_rejection_reason.science_dissemination')
        } else if (reason === 'EvaluatedSubjectMissing') {
          return this.$t('components.publication_element.project_rejection_reason.evaluated_subject_missing')
        } else if (reason === 'NoLeader') {
          return this.$t('components.publication_element.project_rejection_reason.no_leader')
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    allProjectRejectionReasons () {
      const myProjectRejectionReasons = []
      myProjectRejectionReasons.push({ text: 'Wszystko', text_en: 'All', id: '' })
      myProjectRejectionReasons.push({
        text: 'W przypadku instytucji finansującej NAWA punkty zostaną przydzielone oraz projekt zostanie zaliczony do ewaluacji wyłącznie w przypadku, gdy jest współfinansowany przez NAWA i NCN',
        text_en: 'In the case of the financing institution NAWA, points will be assigned and the project will be included in the evaluation only if it is co-financed by NAWA and the National Science Centre',
        id: 'NAWAfinancingCondition'
      })
      myProjectRejectionReasons.push({
        text: 'Data przyznania środków finansowych wykazana przy instytucji finansującej przy podmiocie musi mieścić się w okresie objętym ewaluacją. W przypadku kilku instytucji, data przyznania środków przez każda instytucje mieści się w powyższym okresie',
        text_en: 'The date of granting the funds indicated by the financing institution for the entity must fall within the period covered by the evaluation. In the case of several institutions, the date of granting the funds by each institution falls within the above period',
        id: 'AllGrantsInEvaluationPeriod'
      })
      myProjectRejectionReasons.push({
        text: 'Instytucja finansująca spoza listy instytucji punktowanych',
        text_en: 'Financing institution not included in the list of scored institutions',
        id: 'AnyEvaluatedSourceOfFinancing'
      })
      myProjectRejectionReasons.push({
        text: 'Brak finansowania w trybie konkursowym',
        text_en: 'No competitive financing',
        id: 'FinancingInContestMode'
      })
      myProjectRejectionReasons.push({
        text: 'Kierownik projektu nie ma oświadczenia w czasie trwania projektu',
        text_en: 'The project manager has no statement during the project duration',
        id: 'ProjectManagerStatementsCondition'
      })
      myProjectRejectionReasons.push({
        text: 'Oznaczone jako upowszechnianie nauki',
        text_en: 'Tagged as dissemination of science',
        id: 'ScienceDissemination'
      })
      myProjectRejectionReasons.push({
        text: 'Brak podmiotu realizującego projekt',
        text_en: 'No entity implementing the project',
        id: 'EvaluatedSubjectMissing'
      })
      myProjectRejectionReasons.push({
        text: 'Brak lidera wśród podmiotów realizujących projekt',
        text_en: 'Lack of a leader among the entities implementing the project',
        id: 'NoLeader'
      })
      return myProjectRejectionReasons
    }
  }
}
